import React, { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createSelector } from 'reselect';

import styles from './RankListFour.module.less';
import SoftCardRank4 from '../../components/SoftCardRank4/SoftCardRank4';
import { setIframeVisible } from '../../actions/layout';
import {
  logNative,
  getUrlByTargetContent,
  getSoftType,
  sortSoftsByLocalSoftInit,
} from '../../utils/utils';
import { CONTEXT } from '../../config';
import { logging, logPostInfo } from '../../actions/log';
import { useInView } from 'react-intersection-observer';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectLocalSoftsInit = createSelector(
  state => state.native,
  native => native.installedSoftInit,
);

// let pageSize = 12;
export default memo(({ data, logInfo }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const logInfoData = useSelector(selectLogInfo);
  const localSoftsInit = useSelector(selectLocalSoftsInit);

  const [activitPage, setActivitPage] = useState(0);

  const [showData, setShowData] = useState(null);
  const [showSofts, setShowSofts] = useState([]);
  const [allSofts, setAllSofts] = useState([]);

  const LOG_ACTION_SOURCE = {
    c_more: `${logInfo.clTag || logInfo.tag}_Group_More`,
    c_change: `${logInfo.clTag || logInfo.tag}_Group_Change`,
    source: `${logInfo.tag}_Group`,
  };
  const pageSize = data.row ? parseInt(data.row || '3', 10) * 8 : 24;
  const [ref, inView] = useInView({
    threshold: 1,
  });
  const [refDom, inViewDom] = useInView({
    threshold: 0,
  });

  useEffect(() => {
    if (inView && logInfo && logInfo.changView) {
      logInfo.changView({
        pageCardId: data && data.dataList && data.dataList[0] && data.dataList[0].pageCardContentId,
        pageCardTitle: data && data.title,
        rankCode: data && data.dataList && data.dataList[0] && data.dataList[0].code,
        cardType: data && data.cardType,
        org: data && data.dataList && data.dataList[0] && data.dataList[0].org,
      });
    }
  }, [inView]);

  // 筛洗数据，去除运营配置数据错误情况
  useEffect(() => {
    if (data && data.dataList && data.dataList.length > 0 && data.dataList[0].apps) {
      const allSoftsArr = sortSoftsByLocalSoftInit(data.dataList[0].apps || [], localSoftsInit);
      setAllSofts(allSoftsArr);
      setShowData(data.dataList[0]);
      handleChangeSoft(allSoftsArr, 0, true);
    }
  }, [dispatch, data, localSoftsInit]);

  /**
   * 每一次change 都是数组中循环展示24个  不够就用数组前面的应用组装成24个  这样依次循环展示
   * 根据保存的页码数，获取当前应该展示的24个应用
   */
  const getAppsByPage = useCallback((softAll = [], page = 1) => {
    if (softAll && softAll.length === 0) {
      return [];
    }
    let softArrLoop = softAll;

    while (page * pageSize > softArrLoop.length) {
      softArrLoop = softArrLoop.concat(softAll);
    }
    return softArrLoop.slice((page - 1) * pageSize, page * pageSize);
  }, []);

  const handleChangeSoft = useCallback(
    (allSoft, page, flag) => {
      setActivitPage(page + 1);
      setShowSofts(getAppsByPage(allSoft, page + 1));

      // 点击换一换, flag第一次切换不上报
      if (!flag) {
        dispatch(
          logging({
            category: 'C',
            action: LOG_ACTION_SOURCE.c_more,
            label: '',
            param2: {
              source: `${LOG_ACTION_SOURCE.source}||${showData.pageCardContentId}`,
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              pageCardContentId: showData.pageCardContentId,
              name: showData.name,
            },
          }),
        );
      }
    },
    [dispatch, logInfoData, history, showData],
  );

  const handleShowMore = useCallback(
    bannerInfo => {
      // 推荐页面banner点击打桩
      dispatch(
        logging({
          category: 'C',
          action: LOG_ACTION_SOURCE.c_more,
          label: '',
          param2: {
            source: `${LOG_ACTION_SOURCE.source}||${showData.pageCardContentId}`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            pageCardContentId: showData.pageCardContentId,
            name: showData.name,
          },
          param3: bannerInfo.bizInfo,
        }),
      );
      if (
        bannerInfo.targetType === '1' ||
        bannerInfo.targetType === '3' ||
        bannerInfo.targetType === '11'
      ) {
        dispatch(
          logPostInfo({
            source_p: `${LOG_ACTION_SOURCE.source}||${showData.pageCardContentId}`,
            source_pp: logInfoData.source_p,
          }),
        );
        let url = `${CONTEXT}/`;
        if (bannerInfo.targetType && bannerInfo.targetContent) {
          url = getUrlByTargetContent(bannerInfo);
        }
        history.push(url);
      } else if (bannerInfo.targetType === '2') {
        if (bannerInfo.targetUrl) {
          window.open(bannerInfo.targetUrl);
        } else if (bannerInfo.targetContent) {
          try {
            const targetContent = JSON.parse(bannerInfo.targetContent) || {};
            window.open(targetContent.targetUrl);
          } catch (error) {}
        }
      } else if (bannerInfo.targetType === '5' && bannerInfo.targetContent) {
        let targetContent = {};
        try {
          targetContent = JSON.parse(bannerInfo.targetContent);
        } catch (error) {
          logNative(`分析商城URL JSON解析错误:${error}`, error);
        }
        if (targetContent && targetContent.url) {
          dispatch(
            setIframeVisible({
              visible: true,
              url: targetContent.url,
              source: LOG_ACTION_SOURCE.source,
            }),
          );
        }
      } else {
        history.push(`${CONTEXT}/error`);
      }
    },
    [dispatch, logInfoData, history, showData],
  );

  return showSofts && showSofts.length > 0 ? (
    <div
      className={inViewDom ? styles.card_cardIn : styles.card_cardOut}
      ref={ref}
      data-item={data.cardType}
    >
      <div
        className={styles.card}
        ref={refDom}
        style={{ height: `${24 + parseInt(data.row || '3') * 72}px` }}
      >
        {inViewDom && (
          <>
            <div className={styles.card_header}>
              <div className={styles.card_header_title}>{data.title}</div>
              {data.operate === '2' && (
                <div className={styles.card_header_more} onClick={() => handleShowMore(data)}>
                  更多
                </div>
              )}
              {data.operate === '1' && (
                <div
                  className={styles.header_change}
                  onClick={() => {
                    handleChangeSoft(allSofts, activitPage);
                  }}
                >
                  <i className={`iconfont icon-refresh1 ${styles.header_change_icon}`} />
                  <span>换一换</span>
                </div>
              )}
            </div>
            <div
              className={styles.content_column4}
              style={{ height: `${parseInt(data.row || '3') * 72}px` }}
            >
              {showSofts.map((item, j) => (
                <React.Fragment key={j}>
                  <SoftCardRank4
                    soft={{ ...item, cardShowDesc: true }}
                    logInfo={{
                      ...logInfo,
                      ///////////////////////////
                      softid: item?.androidType === '1' ? item?.packageName : item?.softID,
                      softType: getSoftType(item),
                      contentType: 'soft',
                      rankCode: showData.code,
                      org: showData.org || '',
                      cardType: data.cardType,
                      cardName: data.cardType,
                      pageCardTitle: data.title,
                      pageCardId: showData.pageCardContentId,
                      ///////////////////////////
                      source: `${LOG_ACTION_SOURCE.source}||${showData.pageCardContentId}`,
                      source_p: logInfoData.source_p,
                      source_pp: logInfoData.source_pp,
                    }}
                    key={j}
                  />
                </React.Fragment>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  ) : (
    ''
  );
});
